import React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  loading?: boolean;
  error?: boolean;
  title?: string;
  message?: string;
}

export const PublicPassportShell: React.FC<Props> = ({
  loading,
  error,
  title,
  message,
}) => {
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-canvas">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-brand-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-canvas">
      <div className="bg-shell-900 border-b border-shell-800 px-4 py-3 flex items-center">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <img
            src="/favicon.png"
            alt="Passport"
            className="w-7 h-7 rounded-full object-cover"
            onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
          />
          <span className="text-sm font-semibold text-white">Passport</span>
        </Link>
      </div>
      <div className="min-h-[70vh] flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-sm border border-brand-border p-10 text-center max-w-sm w-full">
          <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 ${error ? 'bg-red-50' : 'bg-brand-50'}`}>
            {error ? (
              <svg className="w-7 h-7 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
            ) : (
              <svg className="w-7 h-7 text-brand-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            )}
          </div>
          {title && <h2 className="text-lg font-bold text-gray-900 mb-2">{title}</h2>}
          {message && <p className="text-sm text-gray-500 leading-relaxed">{message}</p>}
        </div>
      </div>
    </div>
  );
};
